import request from "./axios";

export function login(data) {
    return request({
        url: '/login/login',
        method: 'post',
        data
    })
}
// 首页数据
export function getHomeData(data) {
    return request({
        url: '/index/getHome',
        method: 'post',
        data
    })
}
//获取定位
export function getOperateInfo(data) {
    return request({
        url: '/index/getOperateInfo',
        method: 'post',
        data
    })
}
//获取经营首页数据
export function getOperateData(data) {
    return request({
        url: '/index/getOperateData',
        method: 'post',
        data
    })
}
//获取历史订单数据
export function getOrderData(data) {
    return request({
        url: '/index/getOrderData',
        method: 'post',
        data
    })
}
//获取店铺信息
export function getDianPuInfo(data) {
    return request({
        url: '/index/getDianPuInfo',
        method: 'post',
        data
    })
}
//获取今日订单状况
export function getTodayGaiKuang(data) {
    return request({
        url: '/index/getTodayGaiKuang',
        method: 'post',
        data
    })
}
// 财务分析
export function getFinance(data) {
    return request({
        url: '/index/getFinance',
        method: 'post',
        data
    })
}
// 财务分析历史营业数据单条
export function getHistoryData(data) {
    return request({
        url: '/index/getHistoryData',
        method: 'post',
        data
    })
}
// 流量分析今日数据
export function getLiuLiangTodayInfo(data) {
    return request({
        url: '/index/getLiuLiangTodayInfo',
        method: 'post',
        data
    })
}
// 获取流量分析单条数据
export function getLiuLiangData(data) {
    return request({
        url: '/index/getLiuLiangData',
        method: 'post',
        data
    })
}

// 推广首页
export function getTuiGuangHomeInfo(data) {
    return request({
        url: '/TuiGuangHome/getTuiGuangHomeInfo',
        method: 'post',
        data
    })
}
// 一站式推广
export function getYiZhanShiTuiGuangInfo(data) {
    return request({
        url: '/YIZhanShiTuiGuang/getYiZhanShiTuiGuangInfo',
        method: 'post',
        data
    })
}
// 一站式推广
export function getYiZhanShiTuiGuangHistoryInfo(data) {
    return request({
        url: '/YiZhanShiTuiGuangHistory/getYiZhanShiTuiGuangHistoryInfo',
        method: 'post',
        data
    })
}
// 点金推广
export function getDianShiTuiGuangInfo(data) {
    return request({
        url: '/DianShiTuiGuang/getDianShiTuiGuangInfo',
        method: 'post',
        data
    })
}
// 点金推广
export function getDianShiTuiGuangHistoryInfo(data) {
    return request({
        url: '/DianShiTuiGuangHistory/getDianShiTuiGuangHistoryInfo',
        method: 'post',
        data
    })
}